import { storage } from '../settings';
import { requestFromServer } from '../api/api-client';
import { clearLocalStorage } from '../utils/localStorage';

export const USER_TOKEN = 'userToken';
export const USER_DATA = 'userData';

export function hasToken() {
    return storage.getItem(USER_TOKEN) !== null;
}

export function getAuth() {
    const token = storage.getItem(USER_TOKEN);
    return { Authorization: `Bearer ${token}` };
}

export function setAuth({ token, user }) {
    storage.setItem(USER_TOKEN, token);
    storage.setItem(USER_DATA, JSON.stringify(user));
}

export function clearAuth() {
    storage.removeItem(USER_TOKEN);
    storage.removeItem(USER_DATA);
}

export function getToken() {
    return storage.getItem(USER_TOKEN);
}

export function getUser() {
    const userData = storage.getItem(USER_DATA);
    return userData ? JSON.parse(userData) : null;
}

export const AuthClient = {
    getSetting: async (access_code) => {
        clearLocalStorage();
        const _body = {
            access_code,
        };
        return requestFromServer(`v1/Login/getToken`, 'GET', _body, false);
    },
    postAgreement: async (mode, checked, token) => {
        const _body = {
            mode,
            checked,
        };

        return requestFromServer(`v1/Users/agreement`, 'PUT', _body);
    },
};
